import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';

const faqs = [
  {
    question: 'How does TalentRealm calculate the match score?',
    answer:
      'TalentRealm uses OpenAI Embeddings with cosine similarity to compare resume content against job descriptions. The system returns a score between 0–100%, indicating how closely the candidate’s skills align with the job requirements.',
  },
  {
    question: 'Can recruiters post jobs directly?',
    answer:
      'Yes. Recruiters can create and manage job descriptions directly within TalentRealm, specifying required skills, roles, and experience levels for precise matching.',
  },
  {
    question: 'Is my data secure?',
    answer:
      'Absolutely. We use JWT-based authentication with role-based access control, HTTP-only cookies to prevent XSS/CSRF attacks, and encryption for sensitive data.',
  },
  {
    question: 'Can candidates use TalentRealm for free?',
    answer:
      'Yes. Candidates can upload up to 5 resumes on the Free plan. For unlimited uploads and advanced analytics, upgrade to the Pro plan.',
  },
  {
    question: 'Can TalentRealm integrate with an ATS or HR system?',
    answer:
      'Yes. Enterprise customers can integrate TalentRealm with their ATS via REST APIs or custom connectors for seamless workflows.',
  },
];

export default function FAQ() {
  return (
    <Container
      id="faq"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography component="h2" variant="h4" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Answers to the most common questions recruiters and candidates ask about TalentRealm.
        </Typography>
      </Box>

      <div>
        {faqs.map((faq, index) => (
          <Accordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="h3" variant="subtitle1">
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </Container>
  );
}
